import React from 'react';

export default function MaskIcon({ fill = '#1C274C', stroke = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="40px"
            height="40px"
            viewBox="0 0 511.998 511.998"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}>
            <circle style={{ fill: '#7C54B8' }} cx="255.998" cy="408.96" r="34.167" />
            <path
                style={{ fill: '#674799' }}
                d="M255.997,390.479c16.171,0,29.708,11.237,33.252,26.327c0.591-2.519,0.914-5.141,0.914-7.84
                c0-18.87-15.297-34.167-34.167-34.167s-34.167,15.297-34.167,34.167c0,2.699,0.323,5.321,0.914,7.84
                C226.289,401.716,239.826,390.479,255.997,390.479z"
            />
            <path
                style={{ fill: '#FFDB6C' }}
                d="M280.069,134.387c0.04,0.571,0.087,1.142,0.087,1.724c0,13.343-10.817,24.16-24.16,24.16
                c-13.343,0-24.16-10.817-24.16-24.16c0-0.581,0.047-1.151,0.087-1.723c-37.42-2.368-68.795-9.893-92.222-17.38
                c-6.776-2.166-13.692,2.886-13.692,10.001v98.781c0,82.296,54.814,149.009,122.43,149.009h7.556h7.557
                c67.616,0,122.43-66.713,122.43-149.009v-98.781c0-7.113-6.916-12.167-13.691-10.001
                C348.843,124.502,317.471,132.02,280.069,134.387z M233.027,225.983c-20.356,13.812-48.055,8.508-61.867-11.849l9.189-6.234
                c20.356-13.812,48.055-8.508,61.867,11.849L233.027,225.983z M286.922,225.983l-9.189-6.234l0,0
                c13.812-20.356,41.511-25.661,61.867-11.849l9.189,6.234C334.977,234.491,307.278,239.796,286.922,225.983z"
            />
            <path
                style={{ fill: '#FFB966' }}
                d="M372.292,117.007c-11.604,3.708-25.154,7.421-40.409,10.514v76.185
                c2.656,1.122,5.242,2.514,7.719,4.194l9.189,6.234c-4.443,6.549-10.329,11.529-16.94,14.828
                c-1.25,72.794-45.387,132.746-102.903,143.948c6.349,1.237,12.859,1.888,19.494,1.888h7.556h7.557
                c67.616,0,122.43-66.713,122.43-149.009v-98.781C385.984,119.895,379.068,114.841,372.292,117.007z"
            />
            <circle style={{ fill: '#FD4DD7' }} cx="255.998" cy="136.115" r="24.16" />
            <circle style={{ fill: '#E846AA' }} cx="255.998" cy="136.115" r="10.505" />
            <g>
                <circle style={{ fill: '#7C54B8' }} cx="299.085" cy="167.173" r="8.4" />
                <circle style={{ fill: '#7C54B8' }} cx="327.454" cy="163.443" r="8.4" />
                <circle style={{ fill: '#7C54B8' }} cx="354.525" cy="157.653" r="8.4" />
                <circle style={{ fill: '#7C54B8' }} cx="210.29" cy="168.203" r="8.4" />
                <circle style={{ fill: '#7C54B8' }} cx="181.92" cy="164.473" r="8.4" />
                <circle style={{ fill: '#7C54B8' }} cx="154.861" cy="158.683" r="8.4" />
            </g>
            <path
                style={{ fill: '#FC4C59' }}
                d="M230.319,314.555l-8.598-7.026l0,0c15.566-19.049,43.627-21.873,62.675-6.307l8.598,7.026l0,0
                C277.428,327.297,249.367,330.121,230.319,314.555z"
            />
            <g>
                <path
                    style={{ fill: '#3CC247' }}
                    d="M280.069,134.387c2.301-0.146,4.573-0.316,6.828-0.498c7.343-6.866,14.307-14.598,20.656-23.096
                    c11.168-14.948,19.122-30.509,23.801-45.433c1.842-5.874-4.765-10.844-9.83-7.344c-11.772,8.136-23.115,18.424-33.222,30.525
                    c-2.038,2.44-4.028,4.955-5.958,7.541c-4.918,6.583-9.213,13.286-12.88,19.999v0.001
                    C275.444,120.121,279.529,126.758,280.069,134.387z"
                />
                <path
                    style={{ fill: '#3CC247' }}
                    d="M255.997,111.951c4.99,0,9.611,1.53,13.456,4.123c2.087-11.831,3.221-24.395,3.221-37.43
                    c0-24.128-3.851-46.676-10.53-65.859c-2.036-5.846-10.258-5.846-12.294,0c-6.68,19.182-10.53,41.73-10.53,65.859
                    c0,13.035,1.135,25.599,3.221,37.43C246.386,113.48,251.007,111.951,255.997,111.951z"
                />
                <path
                    style={{ fill: '#3CC247' }}
                    d="M225.122,133.892c2.247,0.183,4.509,0.352,6.802,0.497c0.54-7.631,4.625-14.269,10.609-18.308
                    l-0.01-0.028c-3.667-6.714-7.961-13.417-12.88-19.999c-1.932-2.585-3.92-5.099-5.958-7.541
                    c-10.108-12.101-21.45-22.389-33.222-30.525c-5.065-3.5-11.672,1.468-9.83,7.344c4.681,14.924,12.634,30.486,23.801,45.433
                    C210.792,119.275,217.767,127.017,225.122,133.892z"
                />
            </g>
            <g>
                <path
                    style={{ fill: '#2DA85F' }}
                    d="M298.317,122.13c-3.19-9.659-9.587-17.853-17.938-23.322c-4.094,5.704-7.753,11.481-10.914,17.272
                    v0.001c5.982,4.039,10.066,10.676,10.607,18.305c2.301-0.146,4.573-0.316,6.828-0.498
                    C290.826,130.213,294.641,126.284,298.317,122.13z"
                />
                <path
                    style={{ fill: '#2DA85F' }}
                    d="M255.997,91.541c-5.678,0-11.103,1.073-16.097,3.009c0.532,7.39,1.418,14.586,2.641,21.524
                    c3.845-2.593,8.466-4.123,13.456-4.123s9.611,1.53,13.456,4.123c1.223-6.938,2.109-14.135,2.641-21.524
                    C267.099,92.614,261.675,91.541,255.997,91.541z"
                />
                <path
                    style={{ fill: '#2DA85F' }}
                    d="M213.682,122.116c3.683,4.161,7.505,8.097,11.442,11.775c2.247,0.183,4.509,0.352,6.802,0.497
                    c0.54-7.631,4.625-14.269,10.609-18.308l-0.01-0.028c-3.158-5.784-6.812-11.553-10.899-17.25
                    C223.273,104.27,216.874,112.46,213.682,122.116z"
                />
            </g>
            <path
                d="M385.984,191.677c4.639,0,8.4-3.76,8.4-8.4v-56.268c0-6.103-2.826-11.668-7.753-15.266
                c-4.925-3.597-11.085-4.595-16.895-2.736c-19.942,6.373-40.404,11.057-61.12,14.007c1.944-2.351,3.839-4.747,5.667-7.194
                c11.331-15.167,20.007-31.747,25.087-47.949c1.936-6.177-0.183-12.651-5.4-16.495c-5.177-3.815-11.936-3.922-17.221-0.272
                c-9.895,6.84-19.268,14.95-27.855,24.101c-3.174,3.384-3.005,8.699,0.377,11.874c3.384,3.173,8.699,3.006,11.873-0.379
                c6.345-6.762,13.148-12.885,20.282-18.258c-4.658,12.626-11.712,25.42-20.604,37.321c-4.598,6.154-9.611,11.987-14.957,17.405
                c-0.27-0.619-1.513-6.019-7.338-10.529c1.689-11.081,2.546-22.492,2.546-33.995c0-24.23-3.802-47.959-10.996-68.621
                C267.957,3.936,262.43,0,255.997,0c-6.433,0-11.959,3.936-14.08,10.023c-7.194,20.661-10.997,44.39-10.997,68.622
                c0,11.503,0.857,22.913,2.546,33.995c-0.373,0.358-3.259,3.456-4.237,4.965c-1.122,1.733-2.83,4.94-3.096,5.551
                c-5.35-5.423-10.369-11.259-14.97-17.418c-8.893-11.905-15.947-24.698-20.604-37.322c6.747,5.081,13.205,10.839,19.252,17.17
                c3.204,3.354,8.521,3.477,11.877,0.271c3.354-3.204,3.477-8.521,0.272-11.877c-8.276-8.663-17.266-16.369-26.721-22.903
                c-5.282-3.651-12.041-3.545-17.22,0.272c-5.217,3.844-7.337,10.319-5.4,16.495c5.079,16.199,13.755,32.778,25.087,47.949
                c1.837,2.458,3.74,4.864,5.694,7.225c-20.72-2.95-41.189-7.635-61.138-14.01c-5.811-1.856-11.97-0.864-16.896,2.735
                c-4.927,3.597-7.754,9.162-7.754,15.266v98.78c0,76.902,46.076,141.091,106.755,154.727c-6.793,7.546-10.935,17.521-10.935,28.448
                c0,20.596,14.705,37.819,34.167,41.73v52.904c0,4.64,3.761,8.4,8.4,8.4s8.4-3.76,8.4-8.4v-52.904
                c19.461-3.911,34.167-21.135,34.167-41.73c0-10.927-4.142-20.904-10.935-28.448c60.679-13.637,106.755-77.825,106.755-154.727
                c0-4.64-3.761-8.4-8.4-8.4s-8.4,3.76-8.4,8.4c0,77.533-51.154,140.609-114.03,140.609h-15.112
                c-62.876,0-114.03-63.077-114.03-140.609v-98.78c0-0.884,0.467-1.411,0.86-1.698c0.392-0.286,1.037-0.57,1.874-0.301
                c28.194,9.01,57.38,14.794,86.87,17.224c0.013,0.072,0.031,0.142,0.046,0.214c0.044,0.221,7.162,27.092,33.52,26.181
                c24.498-0.847,30.384-26.316,30.399-26.398c29.492-2.429,58.678-8.214,86.87-17.225c0.839-0.269,1.482,0.017,1.874,0.304
                c0.392,0.287,0.86,0.814,0.86,1.698v56.268C377.584,187.916,381.345,191.677,385.984,191.677z M255.997,434.732
                c-14.208,0-25.767-11.559-25.767-25.767c0-14.208,11.558-25.767,25.767-25.767c14.208,0,25.767,11.559,25.767,25.767
                C281.764,423.173,270.205,434.732,255.997,434.732z M255.997,20.995c5.424,17.596,8.277,37.396,8.277,57.65
                c0,8.639-0.52,17.213-1.548,25.609c-0.535-0.113-3.211-0.703-6.728-0.703c-3.599,0-6.196,0.591-6.729,0.703
                c-1.028-8.394-1.548-16.97-1.548-25.609C247.72,58.391,250.572,38.59,255.997,20.995z M254.388,151.788
                c-7.938-0.809-14.15-7.531-14.15-15.678c0-0.311,0.029-0.618,0.052-0.923l0.015-0.206v-0.001c0.171-2.42,2.528-14.63,15.694-14.63
                c12.687,0,15.522,12.211,15.694,14.631l0.015,0.204c0.022,0.306,0.052,0.614,0.052,0.926c0,8.69-7.07,15.759-15.76,15.759
                C255.453,151.87,254.917,151.842,254.388,151.788z"
                fill={fill}
            />
            <circle cx="299.085" cy="167.173" r="8.4" fill={fill} />
            <circle cx="327.454" cy="163.443" r="8.4" fill={fill} />
            <circle cx="354.525" cy="157.653" r="8.4" fill={fill} />
            <circle cx="210.29" cy="168.203" r="8.4" fill={fill} />
            <circle cx="181.92" cy="164.473" r="8.4" fill={fill} />
            <circle cx="154.861" cy="158.683" r="8.4" fill={fill} />
            <path
                d="M355.74,218.851c1.251-1.844,1.718-4.108,1.299-6.297c-0.419-2.187-1.69-4.119-3.534-5.37l-9.189-6.234
                c-24.154-16.39-57.143-10.073-73.534,14.083c-1.251,1.844-1.718,4.108-1.299,6.297c0.419,2.187,1.69,4.119,3.534,5.37l9.189,6.234
                c9.084,6.165,19.415,9.117,29.647,9.117C328.824,242.051,345.514,233.922,355.74,218.851z M291.639,219.032l-1.421-0.964
                c12.065-11.016,30.57-12.783,44.667-3.217l1.43,0.97c-4.881,4.474-10.918,7.524-17.585,8.8
                C309.25,226.438,299.628,224.453,291.639,219.032z"
                fill={fill}
            />
            <path
                d="M216.405,314.034l8.598,7.026l0,0c9.815,8.02,21.668,11.924,33.451,11.924c15.354,0,30.592-6.63,41.044-19.42
                c2.936-3.593,2.404-8.885-1.189-11.821l-8.598-7.026c-22.605-18.471-56.023-15.109-74.494,7.495
                C212.282,305.806,212.814,311.098,216.405,314.034z M279.08,307.727l1.331,1.088c-12.994,9.904-31.583,10.016-44.777-0.764l0,0
                l-1.331-1.088C247.299,297.061,265.887,296.947,279.08,307.727z"
                fill={fill}
            />
            <path
                d="M208.097,242.051c10.229,0,20.563-2.953,29.647-9.117l9.189-6.234c1.844-1.251,3.115-3.183,3.534-5.37
                c0.419-2.188-0.048-4.454-1.299-6.297c-16.39-24.156-49.378-30.473-73.534-14.083l-9.189,6.234
                c-3.839,2.604-4.84,7.828-2.234,11.667C174.436,233.924,191.123,242.051,208.097,242.051z M185.065,214.851
                c14.099-9.564,32.602-7.801,44.667,3.217l-1.421,0.964c-14.098,9.565-32.602,7.803-44.667-3.217L185.065,214.851z"
                fill={fill}
            />
        </svg>
    );
}
